"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLocale = getLocale;
exports.getLangList = getLangList;
const zh_cn_json_1 = __importDefault(require("./zh-cn.json"));
const zh_tw_json_1 = __importDefault(require("./zh-tw.json"));
const en_us_json_1 = __importDefault(require("./en-us.json"));
const localeMap = new Map([
    ["zh-cn", zh_cn_json_1.default],
    ["zh-tw", zh_tw_json_1.default],
    ["en-us", en_us_json_1.default]
]);
function getLocale(lang) {
    var _a;
    return (_a = localeMap.get(lang)) !== null && _a !== void 0 ? _a : localeMap.get("zh-cn");
}
function getLangList() {
    return Array.from(localeMap.keys());
}
